import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import consoleModule from './modules/ws.console';
import Notifications from 'vue-notification';
import VueClipboard from 'vue-clipboard2';

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueClipboard);

Vue.config.productionTip = false;

Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}

fetch('/config.json')
  .then(response => {
    if (!response.ok) {
      throw new Error("Can't fetch config");
    }
    return response.json();
  })
  .then(data => {
    store.commit('setAppConfig', data);
    const app = new Vue({
      router,
      store,
      render: h => h(App)
    });

    app.$mount('#app');

    if (token) {
      consoleModule({ token });
    }
  })
  .catch(() => {
    document.getElementById('app').innerHTML = 'Error while fetching config';
  });
